
export default {
  name: 'PagePaddockSingle',

  head() {
    return {
      title: `Paw Paddock ${this.compPaddock.name}`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.compPaddock?.description?.substring(0, 155)
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content:
            this.compPaddock.featuredImage && this.compPaddock.featuredImage.length > 0
              ? `${this.compPaddock.featuredImage[0].publicUrl}?height=600&width=1200&trim=${this.compPaddock.imageCropTop};${this.compPaddock.imageCropRight};${this.compPaddock.imageCropBottom};${this.compPaddock.imageCropLeft}`
              : 'https://assets.pawpaddock.co.uk/assets/images/app/og.jpg'
        }
      ]
    }
  },

  computed: {
    compHero() {
      return {
        image:
          this.compPaddock.featuredImage && this.compPaddock.featuredImage.length > 0
            ? `${this.compPaddock.featuredImage[0].publicUrl}?height=400&width=1700&trim=${this.compPaddock.imageCropTop};${this.compPaddock.imageCropRight};${this.compPaddock.imageCropBottom};${this.compPaddock.imageCropLeft}`
            : require('~/assets/images/backgrounds/paddocks-hero-2.jpg'),

        alt: 'Dog in Paw Paddock'
      }
    },

    compPaddock() {
      return this.$store.getters['paddocks/paddockBySlug'](this.$route.params.slug) || {}
    }
  },

  created() {
    if (this.$app.isNative) {
      this.$redirect.to(`/platform/paddocks/${this.$route.params.slug}`)
    }
  },

  methods: {
    onFindOutMore(paddock) {
      this.$redirect.to(`/paddocks/${paddock.slug}`)
    },

    onViewAll() {
      this.$redirect.to(`/paddocks`)
    },

    onBook(paddock) {
      this.$redirect.to(`/book/${paddock.slug}`)
    }
  }
}
